import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useSettingsContext } from 'src/legacy/components/settings';
import LoginLayout from 'src/legacy/layouts/login';
import { useLocales } from 'src/legacy/locales';

import AuthLoginForm from './AuthLoginForm';

const Login = () => {
  const { setVisible } = useSettingsContext();
  const { translate } = useLocales();

  useEffect(() => {
    setVisible(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">{`${translate(
          'sign_in_to_safepoint'
        )}`}</Typography>
      </Stack>

      <AuthLoginForm />
    </LoginLayout>
  );
};

export default Login;
